var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss3Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.575 36.0015L2.36523 0H37.6352L34.422 35.9958L19.9787 40L5.575 36.0015Z",
    fill: "#264DE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6709 33.7035L34.4169 2.94336H20V36.9391L31.6709 33.7035Z",
    fill: "#2965F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72297 16.2963L10.1187 20.7117H19.9995V16.2963H9.72297ZM9.32914 11.7748H19.9995V7.35938H8.92773L9.32914 11.7748ZM19.9995 27.7637L19.9802 27.7688L15.0627 26.441L14.7484 22.9195H10.3159L10.9345 29.8523L19.9792 32.3633L19.9995 32.3576V27.7637Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9844 16.2963V20.7117H25.4215L24.909 26.4382L19.9844 27.7673V32.3611L29.0363 29.8523L29.1027 29.1063L30.1402 17.482L30.248 16.2963L31.0451 7.35938H19.9844V11.7748H26.2062L25.8043 16.2963H19.9844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3Logo);
export default __webpack_public_path__ + "static/media/css-3-logo.f1c2784037dd7074b502afdcc1d2143b.svg";
export { ForwardRef as ReactComponent };